module.exports = __webpack_public_path__ + "img/tianmao.201f8abf.png";